import { CheckCircleFilled, CloseCircleFilled, HourglassFilled, QuestionCircleFilled } from "@ant-design/icons";

enum ContactQualificationAiQualification {
  notInterested = "not_interested",
  considering = "considering",
  interested = "interested",
}

export const contactQualificationAiQualificationAsString = (
  contactQualificationAiQualification: ContactQualificationAiQualification | string
): string => {
  switch (contactQualificationAiQualification) {
    case ContactQualificationAiQualification.interested:
      return "Intéressé";
    case ContactQualificationAiQualification.notInterested:
      return "Inactif"; // (Pas intéressé)
    case ContactQualificationAiQualification.considering:
      return "En réflexion";
    default:
      return "";
  }
};

export const renderContactQualificationAiQualificationOption = (contactQualificationAiQualification: ContactQualificationAiQualification | string): React.ReactNode => {
  switch (contactQualificationAiQualification) {
    case ContactQualificationAiQualification.interested:
      return <>
        <CheckCircleFilled style={{ marginRight: 6, color: 'green' }} />
        {contactQualificationAiQualificationAsString(contactQualificationAiQualification)}</>
    case ContactQualificationAiQualification.notInterested:
      return <>
        <CloseCircleFilled style={{ marginRight: 6, color: 'red' }} />
        {contactQualificationAiQualificationAsString(contactQualificationAiQualification)}</>
    case ContactQualificationAiQualification.considering:
      return <>
        <HourglassFilled style={{ marginRight: 6, color: 'orange' }} />
        {contactQualificationAiQualificationAsString(contactQualificationAiQualification)}</>
    default:
      return <>
        <QuestionCircleFilled style={{ marginRight: 6 }} color="gray" />
        {contactQualificationAiQualificationAsString(contactQualificationAiQualification)}</>
  }
};

export default ContactQualificationAiQualification;
